import { render, staticRenderFns } from "./input.vue?vue&type=template&id=484c4898&"
import script from "./input.vue?vue&type=script&lang=ts&setup=true&"
export * from "./input.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports